import { makeStyles } from '@material-ui/core/styles'


const useStyles = makeStyles((theme) => ({
  set: {
    marginBottom: 24,
    borderBottom: `1px solid ${theme.palette.divider}`
  },
  setsHeaders: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  }
}))

export default useStyles
